import { render, staticRenderFns } from "./StockTrades.vue?vue&type=template&id=b22a4d96&"
import script from "./StockTrades.vue?vue&type=script&lang=ts&"
export * from "./StockTrades.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports